import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css'; // Import the ORIGINAL CSS file
import logo from "./Dhruvologo.png"; // Assuming logo path is correct

// --- Service Data Structure (UPDATED with href for columns) ---
const servicesData = {
  title: "Services",
  href: "/service", // Main link for the Services page itself (optional)
  columns: [
    // Column 1
    {
      title: "Hospital Architecture, Planning and Designing",
      // --- ADDED href for the column title ---
      href: "/services/architecture-planning-designing", // Example Path - CHANGE AS NEEDED
      links: [
        { name: "Master Planning & Campus Design", href: "/services/master-planning" },
        { name: "Medical Planning Services", href: "/services/medical-planning" },
        { name: "Turnkey Architecture Design", href: "/services/turnkey-architecture" },
        { name: "Architectural Design Review", href: "/services/design-review" },
        { name: "Re-modelling, Rennovation & Expansion of Services", href: "/services/remodelling-expansion" },
        { name: "Hospital Project Management Consulting", href: "/services/project-management" },
      ]
    },
    // Column 2
    {
      title: "Hospital Management Consultancy",
      // --- ADDED href for the column title ---
      href: "/services/management-consultancy", // Example Path - CHANGE AS NEEDED
      links: [
        { name: "Market & Financial Feasibility", href: "/services/feasibility" },
        { name: "Accreditation", href: "/services/accreditation" },
        { name: "Medical Equipment Planning", href: "/services/equipment-planning" },
        { name: "Inventory Management", href: "/services/inventory" },
        { name: "Commissioning Assistance", href: "/services/commissioning" },
        { name: "Hospital Information System", href: "/services/his" },
        { name: "Profit Maximization", href: "/services/profit-maximization" },
        { name: "Business Modelling", href: "/services/business-modelling" },
      ]
    },
    // Column 3
    {
      title: "Hospital Operations & Management",
      // --- ADDED href for the column title ---
      href: "/services/operations-management", // Example Path - CHANGE AS NEEDED
      links: [
        { name: "Operations & Management", href: "/services/operations" },
        { name: "Business Development Promotion", href: "/services/business-development" },
        { name: "TPA Management", href: "/services/tpa" },
        { name: "HR & Training", href: "/services/hr-training" },
        { name: "Marketing", href: "/services/marketing" },
      ]
    },
    // Column 4
    {
      title: "Hospital Financial Management",
      // --- ADDED href for the column title ---
      href: "/services/financial-management", // Example Path - CHANGE AS NEEDED
      links: [
        { name: "Day to Day Accounting Management", href: "/services/accounting" },
        { name: "Internal & External Audit", href: "/services/audit" },
        {
          name: "Financial Growth Strategy", // Item with sub-links
          href: "/services/financial-growth", // Optional parent link
          subLinks: [
            { name: "Merger & Acquisition", href: "/services/MergerAcquisition" },

          ]
        },
        { name: "Cost Reduction", href: "/services/cost-reduction" },
        { name: "Assessment Study", href: "/services/assessment" },
      ]
    },
    // Column 5
    {
      title: "Hospital Due Diligence",
      // --- ADDED href for the column title ---
      href: "/services/due-diligence-overview", // Example Path - CHANGE AS NEEDED
      links: [
         /* Add more links if needed */
         // Example: { name: "Technical Due Diligence", href: "/services/technical-due-diligence" },
      ]
    },
  ]
};
// --- End Service Data ---


// Original Logo Component
const Logo = () => (
    <a href="/" className="navbar-logo-link" aria-label="Healthcare Solutions Home">
        <img src={logo} alt="Company Logo" className="navbar-logo-svg" />
    </a>
);

// Original 'About' Dropdown Items
const dropdownItems = [
    { name: 'Why Us', href: '/about' },
    { name: 'Our Team', href: '/ourteam' },
    { name: 'Our Branches', href: '/ourbranches' }, // Assuming this was intended here
    { name: 'FAQ', href: '/faq' },

];


function Navbar() {
  // --- State ---
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false); // Specific for 'About' dropdown
  const [isServicesMegamenuOpen, setIsServicesMegamenuOpen] = useState(false); // Specific for 'Services' megamenu
  const [activeDesktopSubmenu, setActiveDesktopSubmenu] = useState(null); // For desktop level 4 submenu hover
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState({}); // Tracks open accordions { 'About': true, 'Services': true, 'Hospital Architecture...': true, 'Financial Growth Strategy': true }
  const [activeLink, setActiveLink] = useState('Home'); // Keeping original active link logic

  // --- Refs for hover timeouts ---
  const aboutDropdownTimeoutRef = useRef(null);
  const servicesMegamenuTimeoutRef = useRef(null);
  const desktopSubmenuTimeoutRef = useRef(null);

  // --- Mobile Menu Toggle ---
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => {
      const newState = !prev;
      document.body.style.overflow = newState ? 'hidden' : '';
      if (!newState) {
          // Reset ALL mobile accordion states when closing main mobile menu
          setMobileSubmenuOpen({});
          // Also close desktop states just in case
          setIsAboutDropdownOpen(false);
          setIsServicesMegamenuOpen(false);
          setActiveDesktopSubmenu(null);
      }
      return newState;
    });
  };

  // --- Close Mobile Menu & Set Active Link ---
  // Modified: This function now ONLY closes the main mobile menu and resets accordions.
  // It's primarily called by final navigation links or the overlay/hamburger toggle.
  const closeMobileMenuAndReset = (linkName = '') => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = '';
    if (linkName) setActiveLink(linkName);
    // Reset all mobile accordion states when a final link is clicked or menu is closed
    setMobileSubmenuOpen({});
  };

  // --- Resize Listener ---
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992 && isMobileMenuOpen) {
        // Use the function that resets everything when resizing to desktop
        closeMobileMenuAndReset();
      }
      // If resizing large while a desktop menu was left open
      if (window.innerWidth <= 992) {
         setIsAboutDropdownOpen(false);
         setIsServicesMegamenuOpen(false);
         setActiveDesktopSubmenu(null);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileMenuOpen]);

  // --- Scroll Listener ---
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (aboutDropdownTimeoutRef.current) clearTimeout(aboutDropdownTimeoutRef.current);
      if (servicesMegamenuTimeoutRef.current) clearTimeout(servicesMegamenuTimeoutRef.current);
      if (desktopSubmenuTimeoutRef.current) clearTimeout(desktopSubmenuTimeoutRef.current);
      document.body.style.overflow = ''; // Ensure overflow is reset on unmount
    };
  }, []);

  // --- Desktop Hover Logic --- (Keep existing logic)
  const handleAboutEnter = () => {
    if (window.innerWidth > 992) {
        clearTimeout(aboutDropdownTimeoutRef.current);
        setIsServicesMegamenuOpen(false);
        setActiveDesktopSubmenu(null);
        setIsAboutDropdownOpen(true);
    }
  };
  const handleAboutLeave = () => {
     if (window.innerWidth > 992) {
        aboutDropdownTimeoutRef.current = setTimeout(() => setIsAboutDropdownOpen(false), 200);
     }
  };
  const handleServicesEnter = () => {
     if (window.innerWidth > 992) {
        clearTimeout(servicesMegamenuTimeoutRef.current);
        setIsAboutDropdownOpen(false);
        setActiveDesktopSubmenu(null);
        setIsServicesMegamenuOpen(true);
     }
  };
   const handleServicesLeave = () => {
     if (window.innerWidth > 992) {
        // Clear any pending close timeouts for submenus first
        clearTimeout(desktopSubmenuTimeoutRef.current);
        servicesMegamenuTimeoutRef.current = setTimeout(() => {
            // Check if we are NOT currently hovering over an active L4 submenu
            // We rely on activeDesktopSubmenu state for this check
            if (!activeDesktopSubmenu) {
                 setIsServicesMegamenuOpen(false);
            }
        }, 200); // 200ms delay to allow moving to L4
     }
  };
  const handleDesktopSubmenuEnter = (itemName) => {
     if (window.innerWidth > 992) {
        // Clear timeouts that would close the main menu or this submenu
        clearTimeout(servicesMegamenuTimeoutRef.current);
        clearTimeout(desktopSubmenuTimeoutRef.current);
        // Ensure the main megamenu stays open
        setIsServicesMegamenuOpen(true);
        setActiveDesktopSubmenu(itemName);
     }
  };
  const handleDesktopSubmenuLeave = () => {
     if (window.innerWidth > 992) {
        desktopSubmenuTimeoutRef.current = setTimeout(() => {
            setActiveDesktopSubmenu(null);
            // Important: After leaving the L4, immediately re-trigger the check
            // for leaving the main L2 megamenu. This allows the L2 menu to close
            // if the mouse moves completely out.
            handleServicesLeave();
        }, 150); // Shorter delay for L4 leave
     }
  };
  // --- End Desktop Hover Logic ---

  // --- Mobile Accordion Toggle Logic ---
  // *** CORRECTED VERSION ***
  const toggleMobileSubmenu = (itemName) => {
      setMobileSubmenuOpen(prev => ({
          ...prev, // <-- ***** THE CRUCIAL FIX: Keep previous state *****
          [itemName]: !prev[itemName] // Toggle the clicked item
      }));
  };

  // --- Render Helper for Desktop Level 4 Submenu ---
  const renderDesktopSubmenu = (parentItem) => {
      if (!parentItem.subLinks || parentItem.subLinks.length === 0) return null;
      return (
          <ul
              className={`navbar-level4-submenu ${activeDesktopSubmenu === parentItem.name ? 'submenu-open' : ''}`}
              onMouseEnter={() => handleDesktopSubmenuEnter(parentItem.name)}
              onMouseLeave={handleDesktopSubmenuLeave}
          >
              {parentItem.subLinks.map(subLink => (
                  <li key={subLink.name}>
                      {/* Pass parent category name ('Services') for active link state */}
                      <a href={subLink.href} onClick={() => closeMobileMenuAndReset('Services')}>
                          {subLink.name}
                      </a>
                  </li>
              ))}
          </ul>
      );
  };

  // --- Render Helper for Mobile Level 4 Submenu (Accordion Content) ---
  const renderMobileSubmenu = (parentItem) => {
      if (!parentItem.subLinks || parentItem.subLinks.length === 0) return null;
      return (
          <ul className="navbar-mobile-level4-submenu">
              {parentItem.subLinks.map(subLink => (
                  <li key={subLink.name}>
                      {/* Final level links just navigate and close the main menu */}
                      <a href={subLink.href} onClick={() => closeMobileMenuAndReset('Services')}>
                          {subLink.name}
                      </a>
                  </li>
              ))}
          </ul>
      );
  };


  return (
    <>
      {/* Overlay for Mobile */}
       <div
            className={`navbar-mobile-overlay ${isMobileMenuOpen ? 'navbar-overlay-active' : ''}`}
            onClick={toggleMobileMenu} // Close menu on overlay click (toggleMobileMenu handles reset)
        ></div>

      <nav className={`navbar-main ${isScrolled ? 'navbar-scrolled' : ''} ${isMobileMenuOpen ? 'navbar-mobile-active' : ''}`}>
        <div className="navbar-container">
          {/* Logo */}
          <div className="navbar-logo-wrapper">
            <Logo />
          </div>

          {/* Navigation List */}
          <ul className={`navbar-nav ${isMobileMenuOpen ? 'navbar-nav-mobile-open' : ''}`} id="navbar-navigation-list">

            {/* --- Home Link --- */}
            <li className="navbar-nav-item" style={{"--navbar-link-delay": "0.1s"}}>
              <a
                href="/"
                className={`navbar-nav-link ${activeLink === 'Home' ? 'navbar-link-active' : ''}`}
                onClick={() => closeMobileMenuAndReset('Home')} // Use reset function
              >
                <span className="navbar-link-text">Home</span>
              </a>
            </li>

            {/* --- About Dropdown --- */}
            <li
              className={`navbar-nav-item navbar-has-dropdown ${isAboutDropdownOpen ? 'navbar-dropdown-parent-active' : ''}`}
              style={{"--navbar-link-delay": "0.2s"}}
              onMouseEnter={handleAboutEnter}
              onMouseLeave={handleAboutLeave}
            >
              <a
                href="/about" // Link to the main About page
                className={`navbar-nav-link navbar-dropdown-toggle ${activeLink === 'About' ? 'navbar-link-active' : ''}`}
                onClick={(e) => {
                    if (isMobileMenuOpen) {
                        e.preventDefault(); // Prevent navigation on mobile click
                        toggleMobileSubmenu('About'); // Toggle mobile accordion
                    }
                    setActiveLink('About'); // Set active link regardless
                    // Desktop: href="/about" will handle navigation
                }}
                aria-haspopup="true"
                aria-expanded={isMobileMenuOpen ? !!mobileSubmenuOpen['About'] : isAboutDropdownOpen}
              >
                 <span className="navbar-link-text">About</span>
                 {/* Arrow: Show on mobile and desktop hover/open */}
                 <svg className={`navbar-arrow ${(isMobileMenuOpen && mobileSubmenuOpen['About']) || (!isMobileMenuOpen && isAboutDropdownOpen) ? 'navbar-arrow-up' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>

              {/* Desktop 'About' Dropdown Container */}
              <div className={`navbar-dropdown-container ${isAboutDropdownOpen ? 'navbar-dropdown-open' : ''}`}>
                <ul className="navbar-dropdown">
                    <div className="navbar-dropdown-bg"></div> {/* Animated background */}
                    {dropdownItems.map((item, index) => (
                         <li
                            key={item.name}
                            className="navbar-dropdown-item"
                            style={{"--navbar-item-delay": `${index * 0.05}s`}}
                         >
                            <a href={item.href} onClick={() => closeMobileMenuAndReset('About')}> {/* Use reset function */}
                                {item.name}
                                <span className="navbar-dropdown-arrow">→</span>
                            </a>
                         </li>
                    ))}
                </ul>
              </div>

              {/* Mobile 'About' Accordion Content */}
               <div className={`navbar-mobile-submenu-container ${mobileSubmenuOpen['About'] ? 'mobile-submenu-open' : ''}`}>
                   <ul className="navbar-mobile-submenu">
                       {dropdownItems.map((item) => (
                            <li key={item.name} className="mobile-link-item">
                                {/* Use reset function for final links */}
                                <a href={item.href} className="mobile-submenu-link" onClick={() => closeMobileMenuAndReset('About')}>{item.name}</a>
                            </li>
                        ))}
                   </ul>
               </div>
            </li>

            {/* --- Services Megamenu Dropdown --- */}
            <li
                className={`navbar-nav-item navbar-has-megamenu ${isServicesMegamenuOpen ? 'megamenu-parent-active' : ''}`}
                style={{"--navbar-link-delay": "0.3s"}}
                onMouseEnter={handleServicesEnter}
                onMouseLeave={handleServicesLeave}
            >
                <a
                    href={servicesData.href} // Link to the main Services page
                    className={`navbar-nav-link navbar-dropdown-toggle ${activeLink === 'Services' ? 'navbar-link-active' : ''}`}
                    onClick={(e) => {
                        if (isMobileMenuOpen) {
                            e.preventDefault(); // Prevent navigation on mobile click
                            toggleMobileSubmenu(servicesData.title); // Toggle main Services accordion
                        }
                        setActiveLink('Services'); // Set active link regardless
                        // Desktop: href="/service" will handle navigation
                    }}
                    aria-haspopup="true"
                    aria-expanded={isMobileMenuOpen ? !!mobileSubmenuOpen[servicesData.title] : isServicesMegamenuOpen}
                >
                    <span className="navbar-link-text">{servicesData.title}</span>
                    {/* Arrow: Show on mobile accordion toggle */}
                    <svg className={`navbar-arrow ${isMobileMenuOpen && mobileSubmenuOpen[servicesData.title] ? 'navbar-arrow-up' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </a>

                {/* Desktop Services Megamenu Container */}
                <div className={`navbar-services-megamenu ${isServicesMegamenuOpen ? 'megamenu-open' : ''}`}>
                     <div className="megamenu-content-wrapper">
                        {servicesData.columns.map((column, colIndex) => (
                            <div key={colIndex} className="megamenu-column">
                                <a href={column.href} className="megamenu-column-title" onClick={() => closeMobileMenuAndReset('Services')}> {/* Use reset function */}
                                    {column.title}
                                </a>
                                <ul className="megamenu-column-links">
                                    {column.links.map((link, linkIndex) => (
                                        <li
                                            key={link.name}
                                            className={`megamenu-link-item ${link.subLinks ? 'has-submenu' : ''}`}
                                            style={{"--navbar-item-delay": `${(linkIndex * 0.03) + (colIndex * 0.1)}s`}} // Stagger animation
                                            onMouseEnter={() => link.subLinks && handleDesktopSubmenuEnter(link.name)}
                                            onMouseLeave={() => link.subLinks && handleDesktopSubmenuLeave()}
                                        >
                                             {/* Use reset function for final links */}
                                            <a href={link.href} onClick={() => closeMobileMenuAndReset('Services')}>
                                                {link.name}
                                                {link.subLinks && <span className="submenu-indicator"> ›</span>}
                                            </a>
                                            {link.subLinks && renderDesktopSubmenu(link)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                     </div>
                </div>

                 {/* Mobile Services Accordion Content (Level 1 - Main Toggle) */}
                 <div className={`navbar-mobile-submenu-container services-level1 ${mobileSubmenuOpen[servicesData.title] ? 'mobile-submenu-open' : ''}`}>
                     <ul className="navbar-mobile-submenu">
                        {/* Loop for Clickable Column Headers */}
                        {servicesData.columns.map((column, colIndex) => (
                            <li key={column.title} className="mobile-submenu-item has-nested-accordion"> {/* Represents a column */}
                                {/* Clickable Column Title */}
                                <a
                                    href={column.href} // Keep href for potential SEO / right-click context
                                    className="mobile-submenu-link column-toggle" // Style as a link, indicate it toggles
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent navigation, just toggle
                                        toggleMobileSubmenu(column.title); // Toggle THIS column's accordion
                                    }}
                                    aria-expanded={!!mobileSubmenuOpen[column.title]}
                                    aria-controls={`mobile-column-${colIndex}`} // Accessibility
                                >
                                    {column.title}
                                    {/* Arrow Indicator for this column's accordion state */}
                                    <svg className={`navbar-arrow submenu-arrow ${mobileSubmenuOpen[column.title] ? 'navbar-arrow-up' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                </a>

                                {/* Nested Accordion Container for Column Links (Level 2) */}
                                <div
                                     id={`mobile-column-${colIndex}`}
                                     className={`navbar-mobile-submenu-container column-content ${mobileSubmenuOpen[column.title] ? 'mobile-submenu-open' : ''}`}
                                >
                                    <ul className="navbar-mobile-submenu level3"> {/* Deeper level submenu */}
                                        {column.links.map(link => (
                                            <li key={link.name} className={`mobile-link-item ${link.subLinks ? 'has-mobile-submenu' : ''}`}>
                                                {/* Link Item (potentially toggles Level 3) */}
                                                <a
                                                    href={link.href} // Link href
                                                    className="mobile-submenu-link"
                                                    onClick={(e) => {
                                                        if (link.subLinks) {
                                                             e.preventDefault(); // Prevent navigation if it has sub-links
                                                             toggleMobileSubmenu(link.name); // Toggle level 3 accordion
                                                        } else {
                                                            // Is a final link, navigate and close/reset menu
                                                            closeMobileMenuAndReset('Services');
                                                        }
                                                    }}
                                                    aria-expanded={!!mobileSubmenuOpen[link.name]}
                                                    aria-controls={`mobile-level3-${link.name.replace(/\s+/g, '-')}`}
                                                >
                                                    {link.name}
                                                    {/* Arrow indicator for level 3 accordion */}
                                                    {link.subLinks && (
                                                         <svg className={`navbar-arrow submenu-arrow ${mobileSubmenuOpen[link.name] ? 'navbar-arrow-up' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                    )}
                                                </a>
                                                 {/* Container for the mobile Level 3 submenu (accordion content) */}
                                                 {link.subLinks && (
                                                     <div
                                                        id={`mobile-level3-${link.name.replace(/\s+/g, '-')}`}
                                                        className={`navbar-mobile-submenu-container level4 ${mobileSubmenuOpen[link.name] ? 'mobile-submenu-open' : ''}`}
                                                     >
                                                         {/* renderMobileSubmenu calls closeMobileMenuAndReset on final links */}
                                                         {renderMobileSubmenu(link)}
                                                     </div>
                                                 )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        ))}
                     </ul>
                 </div>
            </li>
            {/* --- End Services Megamenu Dropdown --- */}


            {/* --- FAQ's Link --- */}
             <li className="navbar-nav-item" style={{"--navbar-link-delay": "0.4s"}}>
              <a
                href="/faq"
                className={`navbar-nav-link ${activeLink === 'FAQ' ? 'navbar-link-active' : ''}`}
                onClick={() => closeMobileMenuAndReset('FAQ')} // Use reset function
              >
                <span className="navbar-link-text">FAQ's</span>
              </a>
            </li>

            {/* --- Areas We Serve Link --- */}
            <li className="navbar-nav-item" style={{"--navbar-link-delay": "0.45s"}}>
              <a
                href="/ourbranches"
                className={`navbar-nav-link ${activeLink === 'Areas We Serve' ? 'navbar-link-active' : ''}`}
                onClick={() => closeMobileMenuAndReset('Areas We Serve')} // Use reset function
              >
                <span className="navbar-link-text">Areas We Serve</span>
              </a>
            </li>

            {/* --- Contact Us Link --- */}
            <li className="navbar-nav-item navbar-nav-item-contact" style={{"--navbar-link-delay": "0.5s"}}>
              <a
                href="/contact"
                className="navbar-nav-link navbar-contact-link"
                onClick={() => closeMobileMenuAndReset('Contact')} // Use reset function
              >
                 Contact Us
              </a>
            </li>
          </ul>

          {/* Hamburger Toggle Button */}
          <button
              className={`navbar-mobile-toggle ${isMobileMenuOpen ? 'navbar-toggle-active' : ''}`}
              onClick={toggleMobileMenu} // toggleMobileMenu handles state including reset on close
              aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={isMobileMenuOpen}
              aria-controls="navbar-navigation-list"
          >
            <div className="navbar-hamburger-box">
                <div className="navbar-hamburger-inner"></div>
            </div>
          </button>
        </div>
      </nav>
    </>
  );
}

export default Navbar;